import { useMemo } from 'react'
import { useSelector } from 'react-redux'

import { selectAgentCenterId } from '~/agent/store/agent.selectors'
import { useAppDepsContext } from '~/core/hooks/useAppDepsContext'
import { getTariffs } from '~/tariff/store/tariff.selectors'
import { selectTheme } from '~/ui/theme/store/theme.selectors'

export default function UseAnalytics() {
  const brand = useSelector(selectTheme)
  const tariffs = useSelector(getTariffs)
  const affiliation = useSelector(selectAgentCenterId)
  const { analyticsService } = useAppDepsContext()
  const items = useMemo(
    () =>
      Object.values(tariffs)
        .map((tariffState) => {
          const selectedTariffs = tariffState.tariffList.data.filter(
            (candidate) => candidate.id === tariffState.selectedTariffId,
          )
          return selectedTariffs.map((tariff, i) => ({
            id: tariff.id,
            name: tariff.name,
            brand,
            category: tariff.productCategory,
            listName: 'Selector de tarifas',
            listPosition: i,
            price: tariff.price ? tariff.price[tariff.price.length - 1].value : 0,
            quantity: 1,
          }))
        })
        .reduce((acc, i) => [...acc, ...i]),
    [tariffs],
  )

  function addToCart() {
    return analyticsService.addToCart(items)
  }

  function removeFromCart() {
    return analyticsService.removeFromCart(items)
  }

  function purchase(orderId: string) {
    return analyticsService.purchaseComplete({ orderId, affiliation, items })
  }
  return { addToCart, removeFromCart, purchase }
}
